<template lang="html">
<div class="pgInner adsMessage" :style="'height:' + pageH + 'px;'">

      <div class="tabNavs" ref="tabNavs">
           <span>用户审核</span>
           <div class="btns">
                <el-button  @click="goFrash" size="mini">刷新</el-button>
           </div>
      </div>

      <div class="seekLine">
          <div class="seekGp">
              <el-input placeholder="请输入关键字" v-model="listParams.keyword" @input="reInxList">
                    <el-button @click="reInxList" slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div>

          <div class="inpGp">
            <el-select v-model="listParams.status" clearable placeholder="状态" @change="stateChange">
              <el-option
                v-for="item in options"
                :key="item.key"
                :label="item.name"
                :value="item.key">
              </el-option>
            </el-select>
          </div>

      </div>

      <div class="pgbody">

          <el-table
             :data="listData"
             header-row-class-name="tableHead"
             @selection-change="tabSelect"
             v-loading="loading"
             style="width: 100%">

             <!-- <el-table-column
               type="selection"
               align="center"
               width="30">
             </el-table-column> -->

             <el-table-column
               prop="name"
               label="姓名">
             </el-table-column>

            <el-table-column
               prop="phone"
               width="120"
               align="center"
               label="手机号">
             </el-table-column>
             <el-table-column
               prop="jiexiang"
               width="120"
               align="center"
               label="所在街乡">
             </el-table-column>
             <el-table-column
               prop="danwei"
               width="120"
               align="center"
               label="所在企业">
             </el-table-column>
            <el-table-column
               prop="ownePark"
               width="120"
               align="center"
               label="所属功能区">
             </el-table-column>
             

             <el-table-column
               prop="operationUser"
               align="center"
               label="操作用户">
             </el-table-column>

             

             <el-table-column
               prop="createdAt"
               align="center"
               label="申请时间">
             </el-table-column>
            <el-table-column
               width="120"
               align="center"
               label="状态">

                <template slot-scope="scope">
                      {{ scope.row.status | datFormate() }}
                </template>

             </el-table-column>
             <el-table-column
               label="操作"
               align="center"
               width="180">
               <template slot-scope="scope">

                 <div class="ibtn">
                   <span v-if="scope.row.status==0" @click="goReview('review',scope.row)">审核</span>
                   <div class="dvLine"></div>
                 </div>
                 <!-- <div class="ibtn">
                   <span @click="goRemove(scope.row)">删除</span>
                   <div class="dvLine"></div>
                 </div> -->

               </template>

             </el-table-column>
          </el-table>

          <div class="table-footer">

              <!-- <div class="btns" v-if="listData.length > 0">
                  <el-button @click="goRemove()" size="mini" type="danger">删除</el-button>
              </div> -->

              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="handleCurrentChange"
                :current-page="listParams.no"
                :page-size="listParams.size"
                :total="allEls"
                layout="total, prev, pager, next, jumper">
              </el-pagination>

          </div>

      </div>

</div>
</template>

<script>
import { getUserRegisterWhereByFileds } from "@/api/pgMent/userMent";
export default {
    computed:{
      lineStr:function(){
          var str = "left:" + this.navX + "px;";
          return str;
      }
    },
    filters:{
        datFormate:function(e){
            var transMap = {
                    0:'未审核',
                    1:'已通过',
                    2:'未通过'
                };
            return transMap[e];
        }
    },
    data(){
        return{
            pageH:'',

            options:[],
            listData:[],
            selectArr:[],

            loading:false,
            status:'',

            listParams:{
              keyword:'',
              status:0,
              no:1,
              size:12
            },

            allPages:0,
            allEls:0,

            options:[
              { key:0,name:'全部' },
               { key:1,name:'已通过' },
               { key:2,name:'未通过' }
            ],

            typeId:''  // 活动通告类型 id
        }
    },
    methods:{
        getList:function(){
            this.loading = true;
            getUserRegisterWhereByFileds(this.listParams).then(res => {
                console.log(res);
                this.listData = res.userRegisterList;
                this.loading = false;
                this.allPages = res.totalPages;
                this.allEls = res.totalElements;
            })
        },
        stateChange:function(e){
            if(e){
                this.listParams.statusList = [e];
            }else{
                this.listParams.statusList = [];
            }

            this.reInxList();
        },
        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 50;
        },

        selectChange:function(e){
            this.listParams[e.paramsKey] = e.id;
            this.reInxList();
        },

        goRemove:function(e){     // 批量删除
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                this.$confirm('确认要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log('aaa');
                    enterpriseRemove({ids:this.selectArr}).then(res => {
                        console.log(res);
                        vues.reInxList();
                        vues.selectArr = [];
                    })
                }).catch(() => {
                    vues.selectArr = [];
                });
            }else{
                this.$message.error('请选择删除项！');
            }
        },

        changeState:function(status,e){
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                statusSet({ids:this.selectArr,status:status}).then(res => {
                    vues.reInxList();
                    vues.selectArr = [];
                })
            }else{
                this.$message.error('请选择操作项！');
            }
        },

        goReview:function(type,e){   // 编辑
            var querys = {};
            if(type == 'review'){
                querys.id = e.id;
            }
            this.$router.push({
                path:'user_review',
                query: querys
            });
        },

        tabSelect:function(e,type){
            var arrs = [];
            if(type == 1){
                arrs = [e.id];
                this.selectArr = arrs;
                this.goRemove();
            }else{
                e.forEach(item => {
                    arrs.push(item.id);
                })
                this.selectArr = arrs;
            }
        },

        handleCurrentChange:function(e){
            this.listParams.no = e;
            this.getList();
        },
        reInxList:function(){
            this.listParams.no = 1;
            this.getList();
        },
        goFrash:function(){
            this.$emit('go-frash');
        },
        prevSet:function(){

            // 底部定位
            this.pageFix();
            this.typeIdSet();


        },
    },
    created:function(){

        this.pageFix();
        this.getList();

    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.tabNavs{
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  background: white;
  position: relative;
  border-bottom: 1px solid #efefef;
  .btns{
    float: right;
    height: 60px;
    padding-right: 20px;
  }
}

.seekLine{
  padding: 20px;
  background: white;
  .seekGp{
     width: 420px;
     display: inline-block;
  }

  .inpGp{
    width: 150px;
    display: inline-block;
    margin-left: 12px;
  }
}

.pgbody{
  margin: 20px;
  .ibtn{
      display: inline-block;
      font-size: 14px;
      margin-right: 3px;
      span{
         cursor: pointer;
         color: #409EFF;
      }
      .dvLine{
         display: inline-block;
         height: 14px;
         width: 2px;
         vertical-align: middle;
         margin-top: -2px;
         margin-left: 3px;
         background: #EAEAEA;

      }
  }

  .ibtn:last-child .dvLine{
    display: none;
  }

  .table-footer{
    height: 50px;
    background: white;
    padding: 0 30px;
    text-align: right;

    .btns{
      float: left;
      line-height: 50px;
    }

    .paging{
      display: inline-block;
      margin-top: 9px;
    }
  }

}

</style>

<style lang="scss">
.adsMessage .tableHead th{
   background: #efefef;
   font-weight: normal;
   color: #666666;
}

.adsMessage .seekLine{

  .el-input__inner{
    border-radius: 0px !important;
  }

  .el-input-group__append{
    border-radius: 0px !important;
  }

}

</style>



// WEBPACK FOOTER //
// userReviewList.vue?ddda6400